export const targetTypesMockData = [
  {
    id: '62b3fd97909c3683de42caeb',
    createdOn: '2023-03-29T04:16:08.845Z',
    title: 'Game Play',
    description: 'Game Play Repetition',
    priority: 1,
    repetitionType: 'GAME_PLAY',
    repetitionCount: 5
  },
  {
    id: '62b3fd97909c3683de42caed',
    createdOn: '2023-03-29T04:16:08.845Z',
    title: 'Game Score',
    description: 'Game Score',
    priority: 2,
    score: 100
  }
];

export const allLevelsMockData = [
  {
    id: '62bd5547909c3683defbe369',
    xp_required: 0,
    gem: 0,
    chest_type: 1
  },
  {
    id: '62bd5547909c3683defbe36a',
    xp_required: 2,
    gem: 5,
    chest_type: 1
  },
  {
    id: '62bd5547909c3683defbe36c',
    xp_required: 7,
    gem: 10,
    chest_type: 1
  },
  {
    id: '62bd5547909c3683defbe36d',
    xp_required: 12,
    gem: 10,
    chest_type: 1
  },
  {
    id: '62bd5547909c3683defbe36f',
    xp_required: 17,
    gem: 10,
    chest_type: 1
  },
  {
    id: '62bd5547909c3683defbe370',
    xp_required: 22,
    gem: 10,
    chest_type: 1
  },
  {
    id: '62bd5547909c3683defbe372',
    xp_required: 30,
    gem: 12,
    chest_type: 2
  },
  {
    id: '62bd5547909c3683defbe375',
    xp_required: 38,
    gem: 12,
    chest_type: 2
  },
  {
    id: '62bd5547909c3683defbe377',
    xp_required: 46,
    gem: 12,
    chest_type: 2
  },
  {
    id: '62bd5547909c3683defbe379',
    xp_required: 54,
    gem: 12,
    chest_type: 2
  },
  {
    id: '62bd5547909c3683defbe37a',
    xp_required: 64,
    gem: 15,
    chest_type: 3
  },
  {
    id: '62bd5547909c3683defbe37c',
    xp_required: 74,
    gem: 15,
    chest_type: 3
  },
  {
    id: '62bd5547909c3683defbe37d',
    xp_required: 84,
    gem: 15,
    chest_type: 3
  },
  {
    id: '62bd5547909c3683defbe37f',
    xp_required: 94,
    gem: 15,
    chest_type: 3
  },
  {
    id: '62bd5547909c3683defbe380',
    xp_required: 109,
    gem: 20,
    chest_type: 4
  },
  {
    id: '62bd5547909c3683defbe382',
    xp_required: 124,
    gem: 20,
    chest_type: 4
  },
  {
    id: '62bd5547909c3683defbe384',
    xp_required: 139,
    gem: 30,
    chest_type: 5
  },
  {
    id: '62bd5547909c3683defbe386',
    xp_required: 154,
    gem: 20,
    chest_type: 4
  },
  {
    id: '62bd5547909c3683defbe387',
    xp_required: 169,
    gem: 20,
    chest_type: 4
  },
  {
    id: '62bd5547909c3683defbe389',
    xp_required: 184,
    gem: 20,
    chest_type: 4
  },
  {
    id: '62bd5547909c3683defbe38b',
    xp_required: 199,
    gem: 30,
    chest_type: 5
  },
  {
    id: '62bd5547909c3683defbe38c',
    xp_required: 219,
    gem: 30,
    chest_type: 5
  },
  {
    id: '62bd5547909c3683defbe38d',
    xp_required: 239,
    gem: 30,
    chest_type: 5
  },
  {
    id: '62bd5547909c3683defbe38e',
    xp_required: 259,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe390',
    xp_required: 279,
    gem: 30,
    chest_type: 5
  },
  {
    id: '62bd5547909c3683defbe392',
    xp_required: 299,
    gem: 30,
    chest_type: 5
  },
  {
    id: '62bd5547909c3683defbe398',
    xp_required: 329,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe39a',
    xp_required: 359,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe39c',
    xp_required: 389,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe39d',
    xp_required: 419,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe39f',
    xp_required: 449,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe3a2',
    xp_required: 479,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3a4',
    xp_required: 509,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3a6',
    xp_required: 539,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3a8',
    xp_required: 569,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3a9',
    xp_required: 599,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3ab',
    xp_required: 629,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe3ac',
    xp_required: 659,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3ae',
    xp_required: 689,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3b0',
    xp_required: 719,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3b2',
    xp_required: 749,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3b4',
    xp_required: 799,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe3b6',
    xp_required: 829,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3b8',
    xp_required: 859,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3b9',
    xp_required: 889,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3bb',
    xp_required: 919,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3bd',
    xp_required: 949,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe3c2',
    xp_required: 979,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3c5',
    xp_required: 1009,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3c8',
    xp_required: 1039,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3c9',
    xp_required: 1089,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe3ca',
    xp_required: 1139,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe3cd',
    xp_required: 1169,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3cf',
    xp_required: 1199,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3d2',
    xp_required: 1229,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3d3',
    xp_required: 1259,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3d9',
    xp_required: 1289,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe3dc',
    xp_required: 1319,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3dd',
    xp_required: 1349,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3df',
    xp_required: 1379,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3e1',
    xp_required: 1429,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe3e3',
    xp_required: 1479,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe3e5',
    xp_required: 1509,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3e6',
    xp_required: 1539,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3e8',
    xp_required: 1569,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3ea',
    xp_required: 1599,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3ec',
    xp_required: 1629,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe3ee',
    xp_required: 1659,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3f0',
    xp_required: 1689,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3f1',
    xp_required: 1719,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3f3',
    xp_required: 1769,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe3f5',
    xp_required: 1819,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe3f7',
    xp_required: 1849,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3f9',
    xp_required: 1879,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3fb',
    xp_required: 1909,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3fd',
    xp_required: 1939,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe3ff',
    xp_required: 1969,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe401',
    xp_required: 1999,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe403',
    xp_required: 2029,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe405',
    xp_required: 2059,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe407',
    xp_required: 2109,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe409',
    xp_required: 2159,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe40a',
    xp_required: 2189,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe40c',
    xp_required: 2219,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe40e',
    xp_required: 2249,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe410',
    xp_required: 2279,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe412',
    xp_required: 2309,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe414',
    xp_required: 2339,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe416',
    xp_required: 2369,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe418',
    xp_required: 2399,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe41a',
    xp_required: 2449,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe41c',
    xp_required: 2499,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe41e',
    xp_required: 2529,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe420',
    xp_required: 2559,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe422',
    xp_required: 2589,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe424',
    xp_required: 2619,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe426',
    xp_required: 2649,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe428',
    xp_required: 2679,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe42a',
    xp_required: 2709,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe42c',
    xp_required: 2739,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe42e',
    xp_required: 2789,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe430',
    xp_required: 2839,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe432',
    xp_required: 2869,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe434',
    xp_required: 2899,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe436',
    xp_required: 2929,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe438',
    xp_required: 2959,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe43a',
    xp_required: 2989,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe43c',
    xp_required: 3019,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe43e',
    xp_required: 3049,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe43f',
    xp_required: 3079,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe441',
    xp_required: 3129,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe443',
    xp_required: 3179,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe448',
    xp_required: 3209,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe44a',
    xp_required: 3239,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe44d',
    xp_required: 3269,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe450',
    xp_required: 3299,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe453',
    xp_required: 3329,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe455',
    xp_required: 3359,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe458',
    xp_required: 3389,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe45a',
    xp_required: 3419,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe45d',
    xp_required: 3469,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe460',
    xp_required: 3519,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe462',
    xp_required: 3549,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe464',
    xp_required: 3579,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe469',
    xp_required: 3609,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe46c',
    xp_required: 3639,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe46f',
    xp_required: 3669,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe472',
    xp_required: 3699,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe474',
    xp_required: 3729,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe477',
    xp_required: 3759,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe479',
    xp_required: 3809,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe47c',
    xp_required: 3859,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe47d',
    xp_required: 3889,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe480',
    xp_required: 3919,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe483',
    xp_required: 3949,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe486',
    xp_required: 3979,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe488',
    xp_required: 4009,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe489',
    xp_required: 4039,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe48c',
    xp_required: 4069,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe48e',
    xp_required: 4099,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe490',
    xp_required: 4149,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe494',
    xp_required: 4199,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe497',
    xp_required: 4229,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe499',
    xp_required: 4259,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe49c',
    xp_required: 4289,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe49f',
    xp_required: 4319,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4a7',
    xp_required: 4349,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe4b0',
    xp_required: 4379,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4b2',
    xp_required: 4409,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4b6',
    xp_required: 4439,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4b8',
    xp_required: 4489,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4ba',
    xp_required: 4539,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4bd',
    xp_required: 4569,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4be',
    xp_required: 4599,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4c0',
    xp_required: 4629,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4c3',
    xp_required: 4659,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4c5',
    xp_required: 4689,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe4c7',
    xp_required: 4719,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4c9',
    xp_required: 4749,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4cb',
    xp_required: 4779,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4cc',
    xp_required: 4829,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4cf',
    xp_required: 4879,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4d1',
    xp_required: 4909,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4d3',
    xp_required: 4939,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4d4',
    xp_required: 4969,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4d7',
    xp_required: 4999,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4d9',
    xp_required: 5029,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe4db',
    xp_required: 5059,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4dd',
    xp_required: 5089,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4df',
    xp_required: 5119,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4e1',
    xp_required: 5169,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4e3',
    xp_required: 5219,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4e5',
    xp_required: 5249,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4e7',
    xp_required: 5279,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4e9',
    xp_required: 5309,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4eb',
    xp_required: 5339,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4ed',
    xp_required: 5369,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe4ef',
    xp_required: 5399,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4f1',
    xp_required: 5429,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4f3',
    xp_required: 5459,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4f5',
    xp_required: 5509,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4f7',
    xp_required: 5559,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe4f9',
    xp_required: 5589,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4fb',
    xp_required: 5619,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe4fc',
    xp_required: 5649,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe500',
    xp_required: 5679,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe502',
    xp_required: 5709,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe505',
    xp_required: 5739,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe508',
    xp_required: 5769,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe50a',
    xp_required: 5799,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe50c',
    xp_required: 5849,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe50f',
    xp_required: 5899,
    gem: 200,
    chest_type: 8
  },
  {
    id: '62bd5547909c3683defbe512',
    xp_required: 5929,
    gem: 100,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe514',
    xp_required: 5959,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe515',
    xp_required: 5989,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe518',
    xp_required: 6019,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe51a',
    xp_required: 6049,
    gem: 100,
    chest_type: 7
  },
  {
    id: '62bd5547909c3683defbe51c',
    xp_required: 6079,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe51d',
    xp_required: 6109,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe520',
    xp_required: 6139,
    gem: 50,
    chest_type: 6
  },
  {
    id: '62bd5547909c3683defbe522',
    xp_required: 6189,
    gem: 200,
    chest_type: 8
  }
];
